import {creditContributionDefault} from "../../credit_calculator/constants/credit_contribution_default";
import {creditPeriodDefault} from "../../credit_calculator/constants/credit_period_default";
import {calculateInstallment} from "../../credit_calculator/utils/calculate_installment";
import {IPropertyConfiguratorFiltersForm} from "../../property_configurator/types/IPropertyConfiguratorFiltersForm";
import {ISearchFormValues} from "../../search/types/ISearchFormValues";
import {budgetFilterDefaults} from "../constants/budget_filter_defaults";
import {BudgetFieldsNames} from "../types/BudgetFieldsNames";

/**
 * @param searchFormValues - Values from the search form
 * @param defaultType - The default type to use, max is used in property configurator, where we want to have max values for defaults
 * @param listingMaxPrice - The listing max price, usually fetchet from listing data/stats
 * @returns The budget filter default values
 */
export function convertToBudgetFilterDefaultValues(
    searchFormValues: ISearchFormValues,
    defaultType: "mid" | "max",
    listingMaxPrice?: number
): {
    [BudgetFieldsNames.TOTAL]: number;
    [BudgetFieldsNames.CREDIT]: number;
    [BudgetFieldsNames.RADIO]: IPropertyConfiguratorFiltersForm["filterBudget"];
} {
    const formPrice = !searchFormValues.price.upper || searchFormValues.price.upper === "" ? 0 : Number(searchFormValues.price.upper);
    const formInstalment = !searchFormValues.instalment || searchFormValues.instalment === "" ? 0 : Number(searchFormValues.instalment);
    const formBudgetRadio: IPropertyConfiguratorFiltersForm["filterBudget"] = searchFormValues.instalment ? "monthly" : "total";

    const defaultValues =
        defaultType === "mid" ? getMidValues(formPrice, formInstalment, listingMaxPrice) : getMaxValues(formPrice, formInstalment, listingMaxPrice);

    return {
        ...defaultValues,
        [BudgetFieldsNames.RADIO]: formBudgetRadio
    };
}

function getMidValues(formPrice: number, formInstallment: number, listingMaxPrice?: number) {
    const maxPrice = listingMaxPrice && listingMaxPrice > budgetFilterDefaults.totalMax ? listingMaxPrice : budgetFilterDefaults.totalMax;

    const isTooLowPrice = formPrice < budgetFilterDefaults.totalMin;
    const isTooHighPrice = formPrice > maxPrice;

    const defaultPrice = isTooLowPrice ? budgetFilterDefaults.totalValue : isTooHighPrice ? maxPrice : formPrice;

    const maxInstallment = calculateInstallment(maxPrice, creditContributionDefault, creditPeriodDefault);

    const isTooLowMontly = formInstallment < budgetFilterDefaults.monthlyMin;
    const isTooHighMonthly = maxInstallment && formInstallment > maxInstallment;

    const defaultMonthly = isTooLowMontly ? budgetFilterDefaults.monthlyValue : isTooHighMonthly ? maxInstallment : formInstallment;

    return {
        [BudgetFieldsNames.TOTAL]: defaultPrice,
        [BudgetFieldsNames.CREDIT]: defaultMonthly
    };
}

function getMaxValues(formPrice: number, formInstallment: number, listingMaxPrice?: number) {
    const defaultMaxPrice = listingMaxPrice ? listingMaxPrice : budgetFilterDefaults.totalMax;

    const isTooLowPrice = formPrice < budgetFilterDefaults.totalMin;
    const isTooHighPrice = formPrice > defaultMaxPrice;

    const defaultPrice = isTooLowPrice || isTooHighPrice ? defaultMaxPrice : formPrice;

    const maxInstallment = calculateInstallment(defaultMaxPrice, creditContributionDefault, creditPeriodDefault);
    const maxMonthly = maxInstallment ? maxInstallment : budgetFilterDefaults.monthlyMax;

    const isTooLowMontly = formInstallment < budgetFilterDefaults.monthlyMin;
    const isTooHighMonthly = formInstallment > maxMonthly;

    const defaultMonthlyMax = isTooLowMontly || isTooHighMonthly ? maxMonthly : formInstallment;

    return {
        [BudgetFieldsNames.TOTAL]: defaultPrice,
        [BudgetFieldsNames.CREDIT]: defaultMonthlyMax
    };
}
import {creditContributionDefault} from "../../credit_calculator/constants/credit_contribution_default";
import {creditPeriodDefault} from "../../credit_calculator/constants/credit_period_default";
import {calculateInstallment} from "../../credit_calculator/utils/calculate_installment";
import {IPropertyConfiguratorFiltersForm} from "../../property_configurator/types/IPropertyConfiguratorFiltersForm";
import {ISearchFormValues} from "../../search/types/ISearchFormValues";
import {budgetFilterDefaults} from "../constants/budget_filter_defaults";
import {BudgetFieldsNames} from "../types/BudgetFieldsNames";

/**
 * @param searchFormValues - Values from the search form
 * @param defaultType - The default type to use, max is used in property configurator, where we want to have max values for defaults
 * @param listingMaxPrice - The listing max price, usually fetchet from listing data/stats
 * @returns The budget filter default values
 */
export function convertToBudgetFilterDefaultValues(
    searchFormValues: ISearchFormValues,
    defaultType: "mid" | "max",
    listingMaxPrice?: number
): {
    [BudgetFieldsNames.TOTAL]: number;
    [BudgetFieldsNames.CREDIT]: number;
    [BudgetFieldsNames.RADIO]: IPropertyConfiguratorFiltersForm["filterBudget"];
} {
    const formPrice = !searchFormValues.price.upper || searchFormValues.price.upper === "" ? 0 : Number(searchFormValues.price.upper);
    const formInstalment = !searchFormValues.instalment || searchFormValues.instalment === "" ? 0 : Number(searchFormValues.instalment);
    const formBudgetRadio: IPropertyConfiguratorFiltersForm["filterBudget"] = searchFormValues.instalment ? "monthly" : "total";

    const defaultValues =
        defaultType === "mid" ? getMidValues(formPrice, formInstalment, listingMaxPrice) : getMaxValues(formPrice, formInstalment, listingMaxPrice);

    return {
        ...defaultValues,
        [BudgetFieldsNames.RADIO]: formBudgetRadio
    };
}

function getMidValues(formPrice: number, formInstallment: number, listingMaxPrice?: number) {
    const maxPrice = listingMaxPrice && listingMaxPrice > budgetFilterDefaults.totalMax ? listingMaxPrice : budgetFilterDefaults.totalMax;

    const isTooLowPrice = formPrice < budgetFilterDefaults.totalMin;
    const isTooHighPrice = formPrice > maxPrice;

    const defaultPrice = isTooLowPrice ? budgetFilterDefaults.totalValue : isTooHighPrice ? maxPrice : formPrice;

    const maxInstallment = calculateInstallment(maxPrice, creditContributionDefault, creditPeriodDefault);

    const isTooLowMontly = formInstallment < budgetFilterDefaults.monthlyMin;
    const isTooHighMonthly = maxInstallment && formInstallment > maxInstallment;

    const defaultMonthly = isTooLowMontly ? budgetFilterDefaults.monthlyValue : isTooHighMonthly ? maxInstallment : formInstallment;

    return {
        [BudgetFieldsNames.TOTAL]: defaultPrice,
        [BudgetFieldsNames.CREDIT]: defaultMonthly
    };
}

function getMaxValues(formPrice: number, formInstallment: number, listingMaxPrice?: number) {
    const defaultMaxPrice = listingMaxPrice ? listingMaxPrice : budgetFilterDefaults.totalMax;

    const isTooLowPrice = formPrice < budgetFilterDefaults.totalMin;
    const isTooHighPrice = formPrice > defaultMaxPrice;

    const defaultPrice = isTooLowPrice || isTooHighPrice ? defaultMaxPrice : formPrice;

    const maxInstallment = calculateInstallment(defaultMaxPrice, creditContributionDefault, creditPeriodDefault);
    const maxMonthly = maxInstallment ? maxInstallment : budgetFilterDefaults.monthlyMax;

    const isTooLowMontly = formInstallment < budgetFilterDefaults.monthlyMin;
    const isTooHighMonthly = formInstallment > maxMonthly;

    const defaultMonthlyMax = isTooLowMontly || isTooHighMonthly ? maxMonthly : formInstallment;

    return {
        [BudgetFieldsNames.TOTAL]: defaultPrice,
        [BudgetFieldsNames.CREDIT]: defaultMonthlyMax
    };
}
